import React from 'react'
import './Pelicula.scss'
import {withRouter, Link} from 'react-router-dom'
import db from '../../../utils/firebase'
import { Button, Icon, Popup } from 'semantic-ui-react'
import { useAuth } from '../../../context/authContext'
import AdminModificarAlbum from '../../adminModificarAlbum/AdminModificarAlbum'

function Pelicula(props) {


    const{match}=props
    
    const {user,setTitleModal,setContentModal,setShowModal,admin} = useAuth()
    
    const [dataPeli, setDataPeli]= React.useState(null)
    
    const [likes,setLikes]=React.useState(false)
    const [loadingLike,setLoadingLike] = React.useState(false)
    const [reloadLike,setReloadLike]=React.useState(false)


 

    
    React.useEffect(() =>{
        db.collection("peliculas").where("uuidPoster","==", match?.params?.id).get().then((response)=>{

            if(response.docs.length>0){

                const result = response.docs.map((doc)=>{

                    const data = doc.data()
                    data.id=doc.id

                    return{
                        ...data

                    }
                })
                setDataPeli(...result)
            }
            
        })
    },[match?.params?.id])  


      

        React.useEffect(() =>{

            if(dataPeli){
                setLoadingLike(true)
                
              db.collection("likes").where("email","==",user.email).where("uuidPoster","==",dataPeli.uuidPoster).get().then((response)=>{
                if(response.docs.length>0){
                    const result = response.docs.map((doc)=>{
                        const data = doc.data()
                        data.id=doc.id
                        return{
                            like:data.like,

                        }
                    })
                    setLikes(result[0].like)
                    
                }
              }).finally(()=>{
                setLoadingLike(false)
              })

               
            }
          //  setLoadingLike(false)
        },[dataPeli,reloadLike])

    const regresar = () =>{
        props.history.goBack()

    }
    

    const like =  ()  =>{

        if(!loadingLike){
            setLoadingLike(true)
            const l=!likes

                db.collection("likes").where("email","==",user.email).where("uuidPoster","==",dataPeli.uuidPoster).get().then((response)=>{
                    if(response.docs.length>0){
                        const id = response.docs[0].id
                        db.collection("likes").doc(id).update({
                            like:l,
                            createAt:new Date(),
                        }).finally(()=>{
                            setReloadLike(!reloadLike)
                            setLoadingLike(false)
                        })
                    }else{
                        db.collection("likes").add({
                            like:l,
                            createAt:new Date(),
                            uuidPoster:dataPeli.uuidPoster,
                            email:user.email,
                            dataPeli:dataPeli
                        }).finally(()=>{
                            setReloadLike(!reloadLike)
                            setLoadingLike(false)

                        })
                        
                    }
                })
            
        }



      /*  if(numLike === 0){
            setNumLike(numLike+1)
            setCountLike(true)

            

                db.collection("likes").doc(user?.email).collection("pelicula").doc(match?.params?.id).set({
                    like: numLike+1,
                    idLike: match?.params?.id
                })
           
        }
        else if(numLike === 1) {
            setNumLike(numLike-1)
            setCountLike(false)
           

                db.collection("likes").doc(user?.email).collection("pelicula").doc(match?.params?.id).set({
                    like: numLike-1,
                    idLike: match?.params?.id
                })
            
            
        }
        */
        
    }

    const handleAdmin = ()=>{
        setShowModal(true)
        setTitleModal("modificar pelicula")
        setContentModal(<AdminModificarAlbum
                        uuidPoster={match?.params?.id}
                        dataPeli={dataPeli}
        />)
        
    }

    const handleDeletePeli = ()=>{
        db.collection("peliculas").doc(dataPeli.id).delete().then(()=>{
        })
    }

    
    return (
        <div className="pelicula-datos" >
            <Button 
                className="button-regresar" 
                onClick={regresar}
                >
                    <Icon
                        name="angle left"
                        size="small"
                    />
            </Button>
            {
                admin && (
                    <>

                        <Button
                            onClick={()=>handleAdmin()}
                        >
                            admin
                        </Button>
                        <Button
                        onClick={()=>handleDeletePeli()}
                    >
                        Eliminar
                    </Button>
                    </>

                )
            }
            <div className="datos" >
            <img src={dataPeli?.urlPoster} alt=""  />
            
            <h3>{dataPeli?.description}</h3>
            </div>  
            <Link to={`/player/${match?.params?.id}`} >
                <Button  className="button-reproducir"  >Reproducir</Button>
            </Link>
            <Link to={`/play/${match?.params?.id}`} >
                <Button  >TRAILER</Button>
            </Link>

            
                    <Button 
                        className={likes ? "button-like" : "button-deslike"}
                        
                        onClick={like}
                        >
                            <Icon 
                                className={likes ? "icon-like" : "icon-deslike"}
                                name="heart" 
                                loading={loadingLike}
                                />
                    </Button>
            
            
            
                 
              
            
            
            
        </div>
    )
}

export default withRouter(Pelicula)

